/**
 * Defines the direction of a connection point.
 */
export var ConnectionPointDirection;
(function (ConnectionPointDirection) {
    /** Input */
    ConnectionPointDirection[ConnectionPointDirection["Input"] = 0] = "Input";
    /** Output */
    ConnectionPointDirection[ConnectionPointDirection["Output"] = 1] = "Output";
})(ConnectionPointDirection || (ConnectionPointDirection = {}));
//# sourceMappingURL=connectionPointDirection.js.map